module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c4379c5eb21b7cf9b9c94055dde0b582.svg";